import * as React from "react";
import PropTypes from "prop-types";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { PatientData } from "../../Contexts";
import CallVipLink from "../../layout/CallVipLink";

const propTypes = {
  window: PropTypes.func,
  procedureType: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  eligibility: PropTypes.string,
  frequency: PropTypes.string,
  hasReward: PropTypes.bool.isRequired,
};
LearnMore.prototype = propTypes;

export default function LearnMore(props) {
  const patient = React.useContext(PatientData);
  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="baseline"
        pb={2}
        pt={1}
        pl={3}
        pr={1}
      >
        <Grid item xs={12}>
          <Typography variant="h5" mt={1.5} mb={3} color="#0eb482">
            {props.name && props.name + ": "} {props.procedureType}
          </Typography>
        </Grid>
        {props.description && (
          <>
            <Grid item xs={12} md={5.5}>
              <Typography variant="h2" component="div" color="#0eb482" mb={1}>
                Why it's important
              </Typography>
              <Typography variant="body1" gutterBottom>
                {props.description}
              </Typography>
            </Grid>
            <Divider orientation="vertical" flexItem />
          </>
        )}

        <Grid item xs={12} md={6}>
          <Typography variant="h2" component="div" color="#0eb482" mb={1}>
            FAQs
          </Typography>

          {props.frequency && (
            <Typography variant="body1" mb={1}>
              <b>How often do I need to do this? </b>
              {props.frequency}
            </Typography>
          )}

          {props.eligibility && (
            <Typography variant="body1" mb={1}>
              <b>Who needs to do this? </b>
              {props.eligibility}
            </Typography>
          )}

          {props.hasReward && (
            <Typography variant="body1" mb={1}>
              <b> What do I need to do to receive this reward? </b>
              Complete the requirement by the date listed
            </Typography>
          )}
        </Grid>
        <Typography variant="body1" mt={3} mb={1}>
          <b>Need assistance? </b>
          Submit a question or call us at
          <CallVipLink />
        </Typography>
      </Grid>
    </>
  );
}
